import type { ExtractValues } from '../helpers';

export const startIntents = [
  'meeting',
  'delivery',
  'staffOnboard',
  'manager',
  'companion',
  'other',
] as const;

export type StartNLPEngineIntent = ExtractValues<typeof startIntents>;

/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion */
export const nlpEngineIntents = [
  ...startIntents,
  'yesGeneric',
  'noGeneric',
  'askYesOrNo',
  'nameAnnounced',
  'bathroom',
  'fallback',
  'meetingFinish',
  'confirmMeetingVisitor',
  'companion',
  'cancel',
] as const;

export type NLPEngineIntent = ExtractValues<typeof nlpEngineIntents>;
